import { connect } from "react-redux"
import { Dispatch } from "redux"
import { RootState, ReduxAction } from "../../../../reducers"
import { Episode } from "../../../../rpcs/dist/EpisodeRPC"
import { User } from "../../../../rpcs/dist/UserRPC"
import { ActionDispatcher } from "../../actiondispacher/action-dispacher"

export interface IContainerProps {
  episode: Episode
  anonymousUsers: User[] | null
  actions: ActionDispatcher
}

const mapStateToProps = ({ pages }: RootState) => ({
  episode: pages.editor.fetchData.episode,
  anonymousUsers: pages.editor.fetchData.anonymousUsers,
})

const mapDispatchToProps = (dispatch: Dispatch<ReduxAction>) => ({
  actions: new ActionDispatcher(dispatch),
})

export const container = connect(mapStateToProps, mapDispatchToProps)
